import { FC, ReactNode } from "react";
import Typography from "@mui/material/Typography";
import ModalComponent from "@mui/material/Modal";
import Box from "@mui/material/Box";
import { Wrapper, ModalCloseButton } from "./styled";
import CloseIcon from "@mui/icons-material/Close";

const Modal: FC<{
  open: boolean;
  onClose: (value: any) => void;
  title: string;
  content?: ReactNode;
}> = ({ open, onClose, title, content }) => {
  return (
    <ModalComponent open={open} onClose={onClose}>
      <Wrapper>
        <Box display="flex">
          <Typography variant="h5">{title}</Typography>
          <ModalCloseButton onClick={onClose}>
            <CloseIcon />
          </ModalCloseButton>
        </Box>
        <Box sx={{ mt: 2 }}>
          {content ? content : "Контент для модального окна. Поменяется потом."}
        </Box>
      </Wrapper>
    </ModalComponent>
  );
};

export default Modal;
